import Vue from 'vue'
import AuthService from '@/services/authentication.service'

Vue.use(AuthService)

export default function auth ({ next }) {
  return !Vue.prototype.$auth.token() ? next({
    name: 'main'
  }) : next()
}
